import React, { useEffect, useState } from 'react';

//Helpers
import { getSessionCookie } from '../../helpers/cookies';
import { showMessage } from 'helpers/message';

//Contants
import { actionsTable } from '../../constants/MaterialTable';

//Components
import MainCard from '../../components/MainCard/MainCard';
import Loading from '../../components/Loading/Loading';
import TabelaListagem from '../../components/TabelaListagem/TabelaListagem';

//API
import solicitacaoVistoria_api from '../../api/solicitacaoVistoria_api';
import FichaVistoria from '../../views/Shared/Vistoria/FichaVistoria';


function VistoriaTransportador() {
    //Dados do usuario logado
    const usuario = getSessionCookie();

    // guarda o estado para a exibição do loading na tela
    const [loading, setLoading] = useState(false);

    const [listVistorias, setListVistorias] = useState([]);

    const [agendamentoId, setAgendamentoId] = useState(null);

    //Estado de controle dos headers da tabela
    const [headersVistorias, setHeadersVistorias] = useState([
        { value: "Endereço", objectValue: "endereco" },
        { value: "Data de Agedamento", objectValue: "dataAgendamento" },
        { value: "Status", objectValue: "status" },
        { value: "Resultado Final", objectValue: "resultadoFinal" },
    ]);

    const loadListVistorias = () => {
        setLoading(true);
        solicitacaoVistoria_api.GetListTransportadorVistorias().then(response => {
            setListVistorias(response.data);
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    useEffect(() => {
        loadListVistorias()
    }, [])

    //Ações  da tabela
    const actions = [actionsTable.visualizar((item) => {
        if (item.status != "Executado") {
            showMessage("Aviso", "A vistoria ainda não foi executada", "warning", null);
            return;
        } else {
            setAgendamentoId(item.tbSolicitacaoVistoriaAgendamento_Id)
        }
    })];

    if (agendamentoId) {
        return <FichaVistoria
            btnVoltar={() => setAgendamentoId(null)}
            agendamentoId={agendamentoId}
        />
    }

    return <MainCard noCard>
        {loading && <Loading />}
        <TabelaListagem
            actions={actions}
            headers={headersVistorias}
            items={listVistorias}
            title={`Lista de Vistorias`}
            options={{
                print: false,
                search: true,
                pagination: true
            }}
        />
    </MainCard>
}

export default VistoriaTransportador;